module.exports = __webpack_public_path__ + "img/hero.c9dfd32e.png";